import { TickSvg, UpDownArrowSvg, StarSvg, HummerSvg, NotAllowedSvg, SplashSvg, XSvg, CleanSvg } from 'components/icons';
import React from 'react';
import getIsMobile from "components/atoms/utils/getIsMobile";

const isMobile = getIsMobile();

const icons = {
  'Works': <TickSvg filled width={isMobile ? '10' : '12'} height={isMobile ? '8' : '9'} color={window?.settings?.primary_color} />,
  'Doesn\'t Work': <XSvg width={isMobile ? '8' : '9'} height={isMobile ? '8' : '9'} color={window?.settings?.primary_color} />,
  'Yes Issue': <TickSvg filled width={isMobile ? '10' : '12'} height={isMobile ? '8' : '9'} color={window?.settings?.primary_color} />,
  'No Issue': <XSvg width={isMobile ? '8' : '9'} height={isMobile ? '8' : '9'} color={window?.settings?.primary_color} />,
  'Replace': <UpDownArrowSvg width={isMobile ? '13' : '15'} height={isMobile ? '10' : '12'} color={window?.settings?.primary_color} />,
  'Good': <StarSvg filled width={isMobile ? '10' : '12'} height={isMobile ? '10' : '12'} color={window?.settings?.primary_color} />,
  'Repair': <HummerSvg width='16' color={window?.settings?.primary_color} />,
  'N/A': <NotAllowedSvg width='14' color={window?.settings?.primary_color} />,
  'Dirty': <SplashSvg width='20' color={window?.settings?.primary_color} />,
  'Clean': <CleanSvg />
}

export const getIconByName = ({ name }) => {
  return icons[name];
}